<template>
    <div class="class-1">
        <!-- Header -->
        <AppHeader />

        <!-- Driver Registration Form -->
        <div class="container mt-4">
            <div class="row">
                <div class="col-12">
                    <h2>New Driver</h2>
                    <form @submit.prevent="handleRegister">
    <!-- Driver Name Input -->
    <div class="form-row">
        <div class="form-group col-md-12">
            <label for="name">Driver Name</label>
            <div class="input-group">
                <input 
                    type="text" 
                    class="form-control" 
                    id="name" 
                    v-model="form.name" 
                    placeholder="Enter Driver Name" 
                    required
                    ref="nameInput"
                >
                <div class="input-group-append">
                    <button 
                        class="btn btn-outline-secondary" 
                        type="button"
                        @click="openKeypad('nameInput')"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                            <path d="M4.5 10.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-3 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Car Number Input -->
    <div class="form-row">
        <div class="form-group col-md-12">
            <label for="carNumber">Car Number</label>
            <div class="input-group">
                <input 
                    type="text" 
                    class="form-control" 
                    id="carNumber" 
                    v-model="form.carNumber" 
                    placeholder="Enter Car Number" 
                    required
                    ref="carNumberInput"
                >
                <div class="input-group-append">
                    <button 
                        class="btn btn-outline-secondary" 
                        type="button"
                        @click="opennumberpad"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M4.5 1a.5.5 0 0 1 .5.5V3h1.5V1.5a.5.5 0 0 1 1 0V3h1V1.5a.5.5 0 0 1 1 0V3h.5a.5.5 0 0 1 0 1H9v1h1.5a.5.5 0 0 1 0 1H9v1h.5a.5.5 0 0 1 0 1H9v1.5a.5.5 0 0 1-1 0V9H7v1.5a.5.5 0 0 1-1 0V9H4.5a.5.5 0 0 1 0-1H6V7H4.5a.5.5 0 0 1 0-1H6V5H4.5a.5.5 0 0 1 0-1H6V1.5a.5.5 0 0 1 .5-.5h-2z"/>
                            <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1zm11 0H3v14h10V1z"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Status Select -->
    <div class="form-row">
        <div class="form-group col-md-12">
            <label for="isSuspend">Status</label>
            <select 
                id="isSuspend" 
                v-model="form.isSuspend"
                class="form-control"
            >
                <option :value="false">Active</option>
                <option :value="true">Suspended</option>
            </select>
        </div>
    </div>

    <!-- Buttons -->
    <div class="form-row">
        <div class="form-group col-12 d-flex justify-content-between">
            <button type="button" class="btn btn-secondary" @click="cancelForm">
                Cancel
            </button>
            <button type="submit" class="btn btn-primary">
                Submit
            </button>
        </div>
    </div>
</form>
                </div>
            </div>
        </div>

        <!-- Keypad Components -->
        <Keypad ref="keypad" />
        <NumericKeypad 
            ref="numericKeypad"
            :target-input="$refs.carNumberInput"
            @update:value="updateCarNumber"
            @cancel="closeKeypad"
        />
    </div>
</template>

<script>
import NumericKeypad from './NumericKeypad.vue';
import Keypad from './keypad_popup_component.vue';
import { Modal } from 'bootstrap';

export default {
    components: {
        Keypad,
        NumericKeypad
    },
    data() {
        return {
            form: {
                branchId: localStorage.getItem('branchId') || 1,
                name: '',
                carNumber: '',
                isSuspend: false
            },
            currentInput: null,
            keypadModal: null,
            numberModal: null
        };
    },
    mounted() {
        this.$nextTick(() => {
            const numericModalElement = this.$refs.numericKeypad?.$el;
            if (numericModalElement) {
                this.numberModal = new Modal(numericModalElement);
            }
        });
        this.$nextTick(() => {
            const modalElement = this.$refs.keypad.$el;
            this.keypadModal = new Modal(modalElement);
        });
    },
    methods: {
        closeKeypad() {
            if (this.keypadModal) {
                this.keypadModal.hide();
            }
            if (this.numberModal) {
                this.numberModal.hide();
            }
            this.removeBackdrop();
        },
        updateCarNumber(value) {
            this.form.carNumber = value;
            this.closeKeypad();
        },
        removeBackdrop() {
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => backdrop.remove());
            document.body.classList.remove('modal-open');
            document.body.style.paddingRight = '';
        },
        openKeypad(inputRef) {
            this.$refs.keypad.setTargetInput(this.$refs[inputRef]);
            this.keypadModal.show();
        },
        opennumberpad() {
            this.$refs.numericKeypad.inputValue = this.form.carNumber;
            this.numberModal.show();
        },
        cancelForm() {
            this.$router.push('/drivers');
        },
        async handleRegister() {
            try {
                this.$root.isLoading = true; 
                this.loading = true;
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${this.$BASE_API_URL}/api/drivers`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(this.form)
                });

                const data = await response.json();

                if (response.ok) {
                    this.$toast.success('Driver added successfully!');
                    this.$router.push('/drivers');
                } else {
                    this.$toast.error('Failed to add driver: ' + (data.message || 'Unknown error'));
                }
            } catch (error) {
                console.error('Error:', error);
                this.$toast.error('An error occurred. Please try again.');
            }
            finally {
                this.$root.isLoading = false;
                this.loading = false;
            }
        },
        clearForm() {
            this.form = {
                branchId: localStorage.getItem('branchId') || 1,
                name: '',
                carNumber: '',
                isSuspend: false
            };
        }
    }
};
</script>

<style scoped>


.btn {
    padding: 8px 20px;
    border-radius: 4px;
    font-weight: 500;
}

.btn-primary {
    background-color: #007bff;
    border-color: #007bff;
}

.btn-secondary {
    background-color: #6c757d;
    border-color: #6c757d;
}

.btn:hover {
    opacity: 0.9;
}

select.form-control {
    height: calc(2.25rem + 8px);
}
</style>